<ctx-page-template [nocurve]="true">
	<ctx-page-card size="m">
		<!-- todo: create a component that handles error and load states for images -->
		<div
			class="file-details__thumbnail"
			[class.empty]="!thumbnailUrl()"
			[style.background-image]="
				thumbnailUrl() ? 'url(' + thumbnailUrl() + ')' : null
			"
		>
			@if (backFolderId(); as backId) {
				<button
					size="s"
					tuiIconButton
					[routerLink]="nav.folderLink(backId)"
				>
					<tui-icon icon="@tui.arrow-left" />
				</button>
			}

			@if (!thumbnailUrl()) {
				<tui-icon
					class="file-details__thumbnail-placeholder"
					icon="@tui.sprout"
				/>
			}
		</div>

		<div class="file-details__content">
			<div class="file-details__content-header">
				<div class="file-details__content-header-information">
					<h2 class="font-size-medium color-primary">
						{{ file()!.name }}
					</h2>
				</div>
			</div>

			@if (file()!.description; as description) {
				<label>
					<p class="font-bold mb-1 mt-0">
						{{ 'data.description' | transloco }}
					</p>

					<p class="mt-0 mb-5">
						{{ description }}
					</p>
				</label>
			}
		</div>
	</ctx-page-card>

	<div class="w-full max-w-3xl mx-auto">
		<tui-tabs-with-more
			class="file-details__tabs my-4 w-full"
			[activeItemIndex]="tabIndex()"
			(activeItemIndexChange)="onTabChange($event)"
		>
			<button *tuiItem tuiTab type="button" iconStart="@tui.notebook-pen">
				{{ 'file.details.tabs.logs' | transloco }}
			</button>
			<button *tuiItem tuiTab type="button" iconStart="@tui.file-image">
				{{ 'file.details.tabs.media' | transloco }}
			</button>
		</tui-tabs-with-more>

		@switch (tab()) {
			@case ('logs') {
				@if (logsLoading()) {
					<div class="file-details__loader">
						<tui-loader size="xl" />
					</div>
				} @else if (!logs().length) {
					<ctx-table-placeholder
						size="m"
						icon="@tui.notebook-pen"
						[header]="
							'file.details.tabs.log-placeholder-header'
								| transloco
						"
						[content]="
							'file.details.tabs.log-placeholder-content'
								| transloco
						"
					/>
				} @else {
					@for (log of logs(); track log.data.id) {
						<ctx-log-card
							size="s"
							class="mt-4"
							access="view"
							[parent]="file()!"
							[parentRef]="fileRef()!"
							[logRef]="log.ref"
							[log]="log.data"
						/>
					}
				}
			}
			@case ('media') {
				@if (mediaLoading()) {
					<div class="file-details__loader">
						<tui-loader size="xl" />
					</div>
				} @else if (!media().length) {
					<ctx-table-placeholder
						size="m"
						icon="@tui.file-image"
						[header]="
							'file.details.tabs.media-placeholder-header'
								| transloco
						"
						[content]="
							'file.details.tabs.media-placeholder-content'
								| transloco
						"
					/>
				} @else {
					@for (item of media(); track item.data.id) {
						<ctx-media-row
							access="view"
							class="file-details__media-row"
							[parent]="file()!"
							[media]="item.data"
							[mediaRef]="item.ref"
						/>
					}
				}
			}
		}
	</div>
</ctx-page-template>
